import { Component } from '@angular/core';

@Component({
  selector: 'app-page-box',
  standalone: true,
  imports: [],
  templateUrl: './page-box.component.html',
  styleUrl: './page-box.component.scss'
})
export class PageBoxComponent {

}
